import React from 'react';
import { Endpoint } from '../Endpoint.js';
import FontAwesome from 'react-fontawesome';
import { ThermostatGraph } from '../graphs/ThermostatGraph.js';
import $ from 'jquery';

export class ThermostatEndpoint extends Endpoint {
  constructor(props) {
    super(props);

    let onOff = false;
    if (this.props.endpoint.OnOff) {
      if (this.props.endpoint.OnOff.OnOff) {
        onOff = true;
      }
    }

    this.state = {
      endpoint: this.props.endpoint,
      endpointIndex: this.props.endpointIndex,
      token: this.props.token,
      deviceID: this.props.deviceID,
      ieee: this.props.ieee,
      open: false,
      onOff: onOff,
      tunnelURL: this.props.tunnelURL,
      iconOccupiedHeatingSetpoint: 'thermo-temperature__icon',
      iconLoaderOccupiedHeatingSetpoint: 'thermo-temperature__icon',
      iconOccupiedCoolingSetpoint: 'thermo-temperature__icon',
      iconLoaderOccupiedCoolingSetpoint: 'thermo-temperature__icon',
      iconUnoccupiedHeatingSetpoint: 'thermo-temperature__icon',
      iconLoaderUnoccupiedHeatingSetpoint: 'thermo-temperature__icon',
    };

    this.setOccupiedHeatingSetpoint = this.setOccupiedHeatingSetpoint.bind(this);
    this.changeOccupiedHeatingSetpoint = this.changeOccupiedHeatingSetpoint.bind(this);
    this.updateOccupiedHeatingSetpoint = this.updateOccupiedHeatingSetpoint.bind(this);

    this.setOccupiedCoolingSetpoint = this.setOccupiedCoolingSetpoint.bind(this);
    this.changeOccupiedCoolingSetpoint = this.changeOccupiedCoolingSetpoint.bind(this);
    this.updateOccupiedCoolingSetpoint = this.updateOccupiedCoolingSetpoint.bind(this);

    this.setUnoccupiedHeatingSetpoint = this.setUnoccupiedHeatingSetpoint.bind(this);
    this.changeUnoccupiedHeatingSetpoint = this.changeUnoccupiedHeatingSetpoint.bind(this);
    this.updateUnoccupiedHeatingSetpoint = this.updateUnoccupiedHeatingSetpoint.bind(this);
  }

  changeOccupiedHeatingSetpoint(e) {
    if (!isNaN(e.target.value)) {
      let endpoint = this.state.endpoint;
      endpoint.Thermostat.OccupiedHeatingSetpoint = parseFloat(e.target.value) * 100;

      this.setState({ endpoint: endpoint, iconOccupiedHeatingSetpoint: 'thermo-temperature__icon thermo-temperature__icon--visible' });
    }
  }

  setOccupiedHeatingSetpoint(val) {
    let endpoint = this.state.endpoint;
    endpoint.Thermostat.OccupiedHeatingSetpoint = parseFloat(endpoint.Thermostat.OccupiedHeatingSetpoint) + parseFloat(val) * 100;
    this.setState({ endpoint: endpoint, iconOccupiedHeatingSetpoint: 'thermo-temperature__icon thermo-temperature__icon--visible' });
  }

  updateOccupiedHeatingSetpoint() {
    this.setState({ iconOccupiedHeatingSetpoint: 'thermo-temperature__icon', iconLoaderOccupiedHeatingSetpoint: 'thermo-temperature__icon thermo-temperature__icon--visible' });

    $.ajax({
      method: 'POST',
      url: this.state.tunnelURL + '/zigbee/json',
      headers: {
        'x-session': this.props.token,
      },
      xhrFields: {
        withCredentials: true
      },
      data: JSON.stringify({
        Address: this.state.ieee,
        EndPoint: this.state.endpoint.Id,
        Cluster: 'Thermostat',
        Command: 'Write Attributes',
        Parameters: ['OccupiedHeatingSetpoint', this.state.endpoint.Thermostat.OccupiedHeatingSetpoint],
      }),
      dataType: 'JSON',
      success: (res) => {
        this.setState({ iconLoaderOccupiedHeatingSetpoint: 'thermo-temperature__icon' });
      },
      error: (httpReq, status, exception) => {
        this.checkLoginStatus();
      },
    });

  }

  getOccupiedHeatingSetpoint() {
    let setpoint;
    if (this.state.endpoint.Thermostat && this.state.endpoint.Thermostat.hasOwnProperty('OccupiedHeatingSetpoint')) {
      setpoint = (
        <div className="single-device__content__data__row">
          <div className="single-device__content__data__row__label">Occupied Heating Setpoint</div>
          <div className="single-device__content__data__row__content">
            <div className="thermo-temperature">
              <button onClick={ () => this.setOccupiedHeatingSetpoint(-0.5) }>-</button>
              <input value={ this.state.endpoint.Thermostat.OccupiedHeatingSetpoint/100 } onChange={ this.changeOccupiedHeatingSetpoint } />
              <button onClick={ () => this.setOccupiedHeatingSetpoint(0.5) }>+</button>
              <FontAwesome name="check" className={ this.state.iconOccupiedHeatingSetpoint } onClick={ this.updateOccupiedHeatingSetpoint } />
              <FontAwesome name="spinner" className={ this.state.iconLoaderOccupiedHeatingSetpoint } spin />
            </div>
          </div>
        </div>
      );
    }
    return setpoint;
  }

  changeOccupiedCoolingSetpoint(e) {
    if (!isNaN(e.target.value)) {
      let endpoint = this.state.endpoint;
      endpoint.Thermostat.OccupiedCoolingSetpoint = parseFloat(e.target.value) * 100;

      this.setState({ endpoint: endpoint, iconOccupiedCoolingSetpoint: 'thermo-temperature__icon thermo-temperature__icon--visible' });
    }
  }

  setOccupiedCoolingSetpoint(val) {
    let endpoint = this.state.endpoint;
    endpoint.Thermostat.OccupiedCoolingSetpoint = parseFloat(endpoint.Thermostat.OccupiedCoolingSetpoint) + parseFloat(val) * 100;
    this.setState({ endpoint: endpoint, iconOccupiedCoolingSetpoint: 'thermo-temperature__icon thermo-temperature__icon--visible' });
  }

  updateOccupiedCoolingSetpoint() {
    this.setState({ iconOccupiedCoolingSetpoint: 'thermo-temperature__icon', iconLoaderOccupiedCoolingSetpoint: 'thermo-temperature__icon thermo-temperature__icon--visible' });

    $.ajax({
      method: 'POST',
      url: this.state.tunnelURL + '/zigbee/json',
      headers: {
        'x-session': this.props.token,
      },
      xhrFields: {
        withCredentials: true
      },
      data: JSON.stringify({
        Address: this.state.ieee,
        EndPoint: this.state.endpoint.Id,
        Cluster: 'Thermostat',
        Command: 'Write Attributes',
        Parameters: ['OccupiedCoolingSetpoint', this.state.endpoint.Thermostat.OccupiedCoolingSetpoint],
      }),
      dataType: 'JSON',
      success: (res) => {
        this.setState({ iconLoaderOccupiedCoolingSetpoint: 'thermo-temperature__icon' });
      },
      error: (httpReq, status, exception) => {
        this.checkLoginStatus();
      },
    });

  }

  getOccupiedCoolingSetpoint() {
    let setpoint;
    if (this.state.endpoint.Thermostat && this.state.endpoint.Thermostat.hasOwnProperty('OccupiedCoolingSetpoint')) {
      setpoint = (
        <div className="single-device__content__data__row">
          <div className="single-device__content__data__row__label">Occupied Cooling Setpoint</div>
          <div className="single-device__content__data__row__content">
            <div className="thermo-temperature">
              <button onClick={ () => this.setOccupiedCoolingSetpoint(-0.5) }>-</button>
              <input value={ this.state.endpoint.Thermostat.OccupiedCoolingSetpoint/100 } onChange={ this.changeOccupiedCoolingSetpoint } />
              <button onClick={ () => this.setOccupiedCoolingSetpoint(0.5) }>+</button>
              <FontAwesome name="check" className={ this.state.iconOccupiedCoolingSetpoint } onClick={ this.updateOccupiedCoolingSetpoint } />
              <FontAwesome name="spinner" className={ this.state.iconLoaderOccupiedCoolingSetpoint } spin />
            </div>
          </div>
        </div>
      );
    }
    return setpoint;
  }

  changeUnoccupiedHeatingSetpoint(e) {
    if (!isNaN(e.target.value)) {
      let endpoint = this.state.endpoint;
      endpoint.Thermostat.UnoccupiedHeatingSetpoint = parseFloat(e.target.value) * 100;

      this.setState({ endpoint: endpoint, iconUnoccupiedHeatingSetpoint: 'thermo-temperature__icon thermo-temperature__icon--visible' });
    }
  }

  setUnoccupiedHeatingSetpoint(val) {
    let endpoint = this.state.endpoint;
    endpoint.Thermostat.UnoccupiedHeatingSetpoint = parseFloat(endpoint.Thermostat.UnoccupiedHeatingSetpoint) + parseFloat(val) * 100;
    this.setState({ endpoint: endpoint, iconUnoccupiedHeatingSetpoint: 'thermo-temperature__icon thermo-temperature__icon--visible' });
  }

  updateUnoccupiedHeatingSetpoint() {
    this.setState({ iconUnoccupiedHeatingSetpoint: 'thermo-temperature__icon', iconLoaderUnoccupiedHeatingSetpoint: 'thermo-temperature__icon thermo-temperature__icon--visible' });

    $.ajax({
      method: 'POST',
      url: this.state.tunnelURL + '/zigbee/json',
      headers: {
        'x-session': this.props.token,
      },
      xhrFields: {
        withCredentials: true
      },
      data: JSON.stringify({
        Address: this.state.ieee,
        EndPoint: this.state.endpoint.Id,
        Cluster: 'Thermostat',
        Command: 'Write Attributes',
        Parameters: ['UnoccupiedHeatingSetpoint', this.state.endpoint.Thermostat.UnoccupiedHeatingSetpoint],
      }),
      dataType: 'JSON',
      success: (res) => {
        this.setState({ iconLoaderUnoccupiedHeatingSetpoint: 'thermo-temperature__icon' });
      },
      error: (httpReq, status, exception) => {
        this.checkLoginStatus();
      },
    });

  }

  getUnoccupiedHeatingSetpoint() {
    let setpoint;
    if (this.state.endpoint.Thermostat && this.state.endpoint.Thermostat.hasOwnProperty('UnoccupiedHeatingSetpoint')) {
      setpoint = (
        <div className="single-device__content__data__row">
          <div className="single-device__content__data__row__label">Unoccupied Heating Setpoint</div>
          <div className="single-device__content__data__row__content">
            <div className="thermo-temperature">
              <button onClick={ () => this.setUnoccupiedHeatingSetpoint(-0.5) }>-</button>
              <input value={ this.state.endpoint.Thermostat.UnoccupiedHeatingSetpoint/100 } onChange={ this.changeUnoccupiedHeatingSetpoint } />
              <button onClick={ () => this.setUnoccupiedHeatingSetpoint(0.5) }>+</button>
              <FontAwesome name="check" className={ this.state.iconUnoccupiedHeatingSetpoint } onClick={ this.updateUnoccupiedHeatingSetpoint } />
              <FontAwesome name="spinner" className={ this.state.iconLoaderUnoccupiedHeatingSetpoint } spin />
            </div>
          </div>
        </div>
      );
    }
    return setpoint;
  }

  render() {
    return(
      <div className={ this.renderToggleClass() }>
        <div onClick={ this.toggleAccordion } className="single-device__topbar">{ this.renderDeviceType() } <FontAwesome name="plus" className="single-device__topbar__plus" /></div>
        <div className="single-device__content">
          <div className="single-device__content__data">
            { this.getEndpoint() }
            { this.getDeviceId() }
            { this.getId() }
            { this.getProfileName() }
            { this.getManufacturerName() }
            { this.getModelIdentifier() }
            { this.getOnOff() }
            { this.getBattery() }
            { this.getOccupiedHeatingSetpoint() }
            { this.getOccupiedCoolingSetpoint() }
            { this.getUnoccupiedHeatingSetpoint() }

            <ThermostatGraph token={ this.props.token } deviceID={ this.state.deviceID } ieee={ this.state.ieee } endpointIndex={ this.state.endpointIndex } />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/endpoints/ThermostatEndpoint.js